import React, { useCallback, useState } from 'react';

import { DatabaseOutlined, HomeOutlined, PaperClipOutlined, SettingOutlined, ToolOutlined } from '@ant-design/icons';
import { ReceitaType, useReceitas } from './hooks/useReceitas';
import { Badge, Form, Typography } from 'antd';
import { ModalRepublicarGrupos } from './components/ModalRepublicarGrupos';
import { ModalOrganizarGrupo } from './components/ModalOrganizarGrupos';
import { TabelaReceita } from './components/TabelaReceita';
import { GrupoProvider } from './context/GroupContext';
import { ModalReceita } from './components/ModalReceita';
import { stateGlobal } from '../../interfaces/Global';
import { TabelaGrupo } from './components/TabelaGrupo';
import { TabelaRegra } from './components/TabelaRegra';
import { useSelector } from 'react-redux';
import { ModalGrupo } from './components/ModalGrupo';
import { ModalRegra } from './components/ModalRegra';
import { useRegras } from './hooks/useRegras';
import { useGrupo } from './hooks/useGrupos';
import { IGrupos } from './interface';

import GlobalTabs from '../../components/Tabs';
import { TableGerenciarMunicipios } from './components/TabelaGerenciarMunicipios';
import { useGerenciarMunicipios } from './hooks/useGerenciarMunicipios';

const { Title } = Typography;

const ConfiguracoesReceitas: React.FC = () => {
    const [formReceita] = Form.useForm();
    const grupoHook = useGrupo();
    const regraHook = useRegras();
    const gerenciarHook = useGerenciarMunicipios();

    const propsState = useSelector((state: stateGlobal) => state.global);

    const codReceita = useReceitas('CodReceita');

    const [activeType, setActiveType] = useState<ReceitaType>('CodReceita');
    const [editingRecipe, setEditingRecipe] = useState<any>(null);
    const [isOpenModalReceita, setModalOpenReceita] = useState(false);

    const handleOpenModalReceita = (type: ReceitaType, data: any = null) => {
        setActiveType(type);
        setEditingRecipe(data);
        setModalOpenReceita(true);
    };

    const handleSaveReceita = async (values: any) => {
        const hooks = {
            CodReceita: codReceita,
        };
        const codigo = editingRecipe?.codigo_mestre || editingRecipe?.codigo;
        const success = await hooks[activeType].updateReceita(codigo, values);
        if (success) {
            setModalOpenReceita(false);
            formReceita.resetFields();
        }
    };

    const handleGrupoCriado = useCallback((grupo: IGrupos) => {
        formReceita.setFieldsValue({ grupo_id: grupo.id });
    }, [formReceita]);

    const tabItems = [
        {
            key: '1',
            label: (
                <span>
                    Códigos de Receita
                    <Badge
                        count={codReceita.qtdReceitas}
                        overflowCount={999}
                        style={{ backgroundColor: '#52c41a', marginLeft: 8 }}
                    />
                </span>
            ),
            icon: <DatabaseOutlined />,
            children: <TabelaReceita receitasHook={codReceita} theme={propsState.theme} type="CodReceita" onEdit={(data) => handleOpenModalReceita('CodReceita', data)} />,
        },
        {
            key: '2',
            label: 'Configurar Grupos',
            icon: <SettingOutlined />,
            children: <TabelaGrupo theme={propsState.theme} grupoHook={grupoHook} />
        },
        {
            key: '3',
            label: 'Configurar Regras',
            icon: <PaperClipOutlined />,
            children: <TabelaRegra theme={propsState.theme} regraHook={regraHook} />
        },
        {
            key: '4',
            label: 'Gerenciar Municípios',
            icon: <HomeOutlined />,
            children: <TableGerenciarMunicipios theme={propsState.theme} gerenciarHook={gerenciarHook} />
        },
    ];

    return (
        <GrupoProvider>
            <Title
                level={4}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                <ToolOutlined />
                Configurações de Receitas
            </Title>
            <GlobalTabs
                items={tabItems}
                defaultActiveKey="1"
            />
            <ModalReceita
                data={editingRecipe}
                grupoHook={grupoHook}
                getReceitaByCodigo={codReceita.getReceitaByCodigo}
                onSave={handleSaveReceita}
                visible={isOpenModalReceita}
                onClose={() => setModalOpenReceita(false)}
                loading={codReceita.loadingUpdate}
            />
            <ModalGrupo
                hook={grupoHook}
                onCreatedGrupo={handleGrupoCriado}
            />
            <ModalOrganizarGrupo
                hook={grupoHook}
            />
            <ModalRepublicarGrupos
                hook={grupoHook}
            />
            <ModalRegra
                hook={regraHook}
            />
        </GrupoProvider>
    );
};

export default ConfiguracoesReceitas;
